export enum MessageActor {
  AGENT = "AGENT",
  USER = "USER"
}

export enum AiProcessStatus {
  IDLE = "IDLE",
  RUNNING = "RUNNING",
  FAILED = "FAILED"
}

export enum AiChatActionType {
  CONFIRM_ITEMS = 'confirm_items',
  CONFIRM_REMAINING_ITEMS = 'confirm_remaining_items',
  EDIT_ITEMS = 'edit_items',
  ACCEPT_PROPOSAL = 'accept_proposal',
  REJECT_PROPOSAL = 'reject_proposal',
  YES = 'yes',
  NO = 'no',
  INCLUDE_PAYMENT_AGENT = 'include_payment_agent',
  DECLINE_PAYMENT_AGENT = 'decline_payment_agent',
  ACCEPT = 'accept',
}

export enum ShipmentStatus {
  DRAFT = "DRAFT",
  CONFIRMED_ITEMS = "CONFIRMED_ITEMS",
  WEIGHT_CONFIRMED = "WEIGHT_CONFIRMED",
  DONE = "DONE",
  CANCELLED = "CANCELLED",
}

export enum MessageType {
  TEXT = "TEXT",
  WIDGET_ITEMS = "WIDGET_ITEMS",
  WIDGET_PROPOSAL = "WIDGET_PROPOSAL",
  QUESTION_OPTIONS = "QUESTION_OPTIONS",
  WIDGET_FIRST_PAYMENT = 'WIDGET_FIRST_PAYMENT'
}

export type ChatMessageType = {
  message_id: number;
  actor: MessageActor;
  response_type: MessageType;
  response_text: string;
  options: string[];
  actions: AiChatActionType[] | null;
  files: FileDescriptor[];
}

export type ChatSession = {
  created_at: string;
  id: number;
  invoice_advance_percent?: number | null;
  invoice_number?: string;
  items_count: number;
  message_history: ChatMessageType[];
  remaining_composition_review?: boolean;
  requires_revised_invoice?: boolean;
  shipment_status: ShipmentStatus;
  supplier_name?: string;
  title: string;
};

export type SessionIdentityRole = 'OWNER' | 'USER';

export interface SessionIdentityActor {
  email?: string;
  name?: string;
  phone?: string;
  role: SessionIdentityRole;
  user_id: string;
}

export interface SessionIdentityContext {
  actor: SessionIdentityActor;
  organization: SessionIdentityOrganization;
}

export interface SessionIdentityOrganization {
  address: string;
  inn: string;
  kpp?: string;
  legal_address?: string;
  legal_entity_id?: string;
  legal_name: string;
  ogrn?: string;
  org_id: string;
  short_name?: string;
}

export interface CreateSessionRequest {
  user_id: string;
  org_id: string;
}

export type FileDescriptor = {
  id: number;
  name: string;
};

export type FileUploadResponse = {
  filename: string | null;
  id: number;
};

export type AiProcessStatusRes = {
  status: AiProcessStatus;
  current_step: AIProcessCurrentStep;
}

export type SendMessageRequest = {
  session_id: number;
  user_text: string;
  file_ids: number[];
  action_id: AiChatActionType;
  reply_message_id: number;
}

export type InvoiceItem = {
  id: number;
  shipment_id: number;
  line_no: number;
  title: string;
  quantity: number;
  unit_price: string;
  total_amount: string;
  weight_net_kg: string | null;
  weight_gross_kg: string | null;
  unit_of_measure: string;
  country_of_origin: string;
  volume_m3: string;
  packages_count: 0;
  packaging_type: string;
  article_sku: string;
  brand: string;
  model: string;
  manufacturer: string;
  material_or_composition: string;
  ean_or_barcode: string;
  currency: string;
  created_at: string;
  updated_at: string;
}

export type BudgetProposalWidget = {
  core_shipment_id: string | null;
  customs_rub: string;
  deal_total_goods?: string | null;
  deal_total_rub?: string | null;
  fx_rate_date?: string | null;
  fx_rate_rub_per_unit?: string | null;
  goods_cost: string;
  goods_cost_rub?: string | null;
  goods_currency: string;
  logistics_services_rub: string;
  payment_agent_fee_goods: number | null;
  payment_agent_fee_rub: number | null;
  requires_revised_invoice?: boolean;
  total_goods?: string | null;
  total_rub: string;
};

export type GetKpUrlResponse = {
  commercial_proposal: {
    filename: string;
    expires_at: string;
    url: string;
  };
  shipment_id: string;
}

export enum AIProcessCurrentStep {
  INTAKE_DOCUMENTS = "INTAKE_DOCUMENTS",
  INTAKE_URLS = "INTAKE_URLS",
  CONFIRM_SUPPLIER = "CONFIRM_SUPPLIER",
  CHECK_SUPPLIER_EXPORT_LICENSE = "CHECK_SUPPLIER_EXPORT_LICENSE",
  CHECK_SUPPLIER_PAYMENT = "CHECK_SUPPLIER_PAYMENT",
  WL_PAYMENT_OFFER = "WL_PAYMENT_OFFER",
  CONFIRM_COMPOSITION = "CONFIRM_COMPOSITION",
  CONFIRM_WL_FIRST_PAYMENT = "CONFIRM_WL_FIRST_PAYMENT",
  ENRICH_ITEMS = "ENRICH_ITEMS",
  D31_CLARIFY = "D31_CLARIFY",
  SELECT_HS_CANDIDATES = "SELECT_HS_CANDIDATES",
  // подэтап внутри подбора кандидатов: интернет-исследование товаров (AI: PSEUDO_STEPS)
  WEB_RESEARCH = "WEB_RESEARCH",
  HS_SCOPE_CLARIFY = "HS_SCOPE_CLARIFY",
  CLASSIFY_HS = "CLASSIFY_HS",
  HS_CLARIFY = "HS_CLARIFY",
  DESCRIBE_UNRESOLVED_ITEMS = "DESCRIBE_UNRESOLVED_ITEMS",
  RESOLVE_DEAD_END_TEXT = "RESOLVE_DEAD_END_TEXT",
  ENSURE_WEIGHTS = "ENSURE_WEIGHTS",
  CONFIRM_WEIGHT = "CONFIRM_WEIGHT",
  CALCULATE_CUSTOMS_PAYMENTS = "CALCULATE_CUSTOMS_PAYMENTS",
  DETERMINE_PERMITS = "DETERMINE_PERMITS",
  PERMITS_CLARIFY = "PERMITS_CLARIFY",
  MARKING = "MARKING",
  PERMIT_LOOKUP = "PERMIT_LOOKUP",
  REGISTER_CORE_DRAFT = "REGISTER_CORE_DRAFT",
  BUILD_PROPOSAL = "BUILD_PROPOSAL"
}

export type AiCarouselItem = {
  key: string;
  icon: string | null;
  steps: string[];
  messages: string[];
}